import { QUERIES } from '@repo/ui/queries';
import { createGlobalStyle } from 'styled-components';

import { layoutConstants } from 'styles/layoutConstants';

export const GlobalStyles = createGlobalStyle`
  :root {
    --header-height:  ${layoutConstants.mobileHeaderHeight};
    --banner-height:  38px;
  }

  ${QUERIES.largeTabletAndUp} {
    :root {
      --header-height: ${layoutConstants.headerHeight};
    }
  }
`;
